import React, { useState, useEffect } from 'react';
import { COLORS } from '../App';
import { getDeals } from '../api';

const API_BASE = window.location.port === '3000' ? 'http://localhost:4100/api' : window.location.pathname.startsWith('/cmbs') ? '/cmbs/api' : '/api';

const STATUS_COLORS = {
  intake: '#3498DB',
  extraction: '#9B59B6',
  underwriting: '#E67E22',
  comps: '#1ABC9C',
  bid: '#F39C12',
  termsheet: '#2ECC71',
  asr: '#27AE60',
  qa: '#8E44AD',
  closed: '#2C3E50',
};

export default function DealPipeline({ onOpenDeal, onNewDeal }) {
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    loadDeals();
  }, []);

  const loadDeals = async () => {
    try {
      const res = await getDeals();
      setDeals(res.data.filter((d) => d.status !== 'deleted'));
    } catch (err) {
      console.error('Failed to load deals:', err);
    }
    setLoading(false);
  };

  const handleDelete = async (e, deal) => {
    e.stopPropagation();
    if (!window.confirm(`Delete deal "${deal.property_name}"? This will permanently remove all files, extraction data, documents, and history for this deal.`)) return;
    const token = localStorage.getItem('cmbs_token');
    const res = await fetch(`${API_BASE}/deals/${deal.id}`, {
      method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` },
    }).then(r => r.json());
    if (res.success) {
      setDeals(deals.filter(d => d.id !== deal.id));
    } else {
      alert(res.error || 'Failed to delete deal');
    }
  };

  const filtered = deals.filter((d) =>
    !filter || d.property_name.toLowerCase().includes(filter.toLowerCase()) ||
    (d.brokerage && d.brokerage.toLowerCase().includes(filter.toLowerCase()))
  );

  const card = {
    background: COLORS.white,
    borderRadius: 8,
    border: `1px solid ${COLORS.border}`,
    padding: 24,
  };

  const formatCurrency = (val) => {
    if (!val) return '';
    return '$' + Number(val).toLocaleString('en-US', { maximumFractionDigits: 0 });
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <input
            placeholder="Search deals..."
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            style={{ padding: '8px 14px', border: `1px solid ${COLORS.border}`, borderRadius: 4, fontSize: 14, width: 280 }}
          />
          <span style={{ color: COLORS.textLight, fontSize: 13 }}>{filtered.length} deals</span>
        </div>
        <button onClick={onNewDeal} style={{ padding: '10px 20px', background: COLORS.gold, color: COLORS.navy, border: 'none', borderRadius: 4, fontWeight: 600, cursor: 'pointer', fontSize: 14 }}>
          + New Deal
        </button>
      </div>

      {loading ? (
        <div style={{ ...card, textAlign: 'center', color: COLORS.textLight }}>Loading deals...</div>
      ) : filtered.length === 0 ? (
        <div style={{ ...card, textAlign: 'center', color: COLORS.textLight }}>
          No deals found. Click "+ New Deal" to create your first deal.
        </div>
      ) : (
        <div style={card}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: `2px solid ${COLORS.border}` }}>
                {['Property', 'Type', 'Brokerage', 'Loan Amount', 'Status', 'Originator', 'Created', ''].map((h, i) => (
                  <th key={i} style={{ textAlign: 'left', padding: '10px 12px', fontSize: 12, color: COLORS.textLight, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', width: h === '' ? 40 : undefined }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map((deal) => (
                <tr key={deal.id} onClick={() => onOpenDeal(deal.id)}
                  style={{ borderBottom: `1px solid ${COLORS.border}`, cursor: 'pointer', transition: 'background 0.1s' }}
                  onMouseEnter={(e) => e.currentTarget.style.background = '#F8F9FA'}
                  onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}>
                  <td style={{ padding: '12px', fontSize: 14, fontWeight: 500, color: COLORS.navy }}>{deal.property_name}</td>
                  <td style={{ padding: '12px', fontSize: 13, color: COLORS.text }}>{deal.property_type || ''}</td>
                  <td style={{ padding: '12px', fontSize: 13, color: COLORS.text }}>{deal.brokerage || ''}</td>
                  <td style={{ padding: '12px', fontSize: 13, color: COLORS.text }}>{formatCurrency(deal.loan_amount)}</td>
                  <td style={{ padding: '12px' }}>
                    <span style={{
                      display: 'inline-block', padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: 600,
                      background: (STATUS_COLORS[deal.status] || '#999') + '20',
                      color: STATUS_COLORS[deal.status] || '#999',
                    }}>{deal.status}</span>
                  </td>
                  <td style={{ padding: '12px', fontSize: 13, color: COLORS.text }}>{deal.originator_name || ''}</td>
                  <td style={{ padding: '12px', fontSize: 12, color: COLORS.textLight }}>{new Date(deal.created_at).toLocaleDateString()}</td>
                  <td style={{ padding: '4px 8px', textAlign: 'center' }}>
                    <button onClick={(e) => handleDelete(e, deal)}
                      style={{ padding: '4px 8px', background: 'transparent', border: 'none', cursor: 'pointer', fontSize: 13, color: '#999', borderRadius: 4 }}
                      onMouseEnter={(e) => e.currentTarget.style.color = '#C62828'}
                      onMouseLeave={(e) => e.currentTarget.style.color = '#999'}
                      title="Delete deal">
                      X
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
